// Defensive readers for chatbot wire payloads, whose fields arrive in several historic shapes.

export function firstStringList(...values: unknown[]): string[] {
  for (const value of values) {
    const strings = stringList(value)
    if (strings) return strings
  }
  return []
}

export function stringList(value: unknown): string[] | null {
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === 'string')
    : null
}

export function firstRecord(...values: unknown[]): Record<string, unknown> | null {
  for (const value of values) {
    const record = recordOrNull(value)
    if (record) return record
  }
  return null
}

export function firstString(...values: unknown[]): string | null {
  for (const value of values) {
    const string = stringOrNull(value)
    if (string) return string
  }
  return null
}

export function firstFiniteNumber(...values: unknown[]): number | null {
  for (const value of values) {
    if (typeof value === 'number' && Number.isFinite(value)) return value
  }
  return null
}

export function stringOrNull(value: unknown): string | null {
  return typeof value === 'string' ? value : null
}

export function arrayOrNull<T>(value: T[] | undefined): T[] | null {
  return Array.isArray(value) ? value : null
}

export function recordOrNull(value: unknown): Record<string, unknown> | null {
  return isRecord(value) ? value : null
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value && typeof value === 'object' && !Array.isArray(value))
}
